import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

class FilterResultsStore extends ReduceStore {

    getInitialState() {
        return {isFetching: false, fetchedAll: false, results: {}};
    }

    isFetching() {
        return this.getState().isFetching;
    }

    fetchedAll() {
        return this.getState().fetchedAll;
    }

    getResults(id) {
        return this.getState().results[id];
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.FILTER_RESULTS_REQUEST:
                return update(this.getState(), { isFetching: { $set: true }});

            case ActionTypes.FILTER_RESULTS_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: false },
                    fetchedAll: { $set: action.data.length === 0 },
                    results: {
                        [action.payload.id]: {
                            $set: action.payload.clearAll ? action.data : [...this.getState().results[action.payload.id], ...action.data]
                        }
                    }
                });

            case ActionTypes.FILTER_RESULTS_FAILURE:
                return update(this.getState(), { isFetching: { $set: false } });

            default:
                return state;
        }
    }
}

export default new FilterResultsStore(CentricDispatcher);
